import { APPROVAL_LIST, ACCEPT, REJECT ,INS_APPROVAL_LIST,INS_DETAILS_LIST, LEAD_APPROVAL_LIST,EXISTING_PROJECT_LIST,TAG_APPROVAL_LIST, TAG_DETAILS_LIST, SAVE_LOGS_FOR_CONTRACT} from "./type";

const initalState = {
    approvalList: {},
    insApprovalList:{},
    insDetails:{},
    accept: null,
    reject: null,
    leadApprovalList: {},
  existingProjectList: [],
    tagApprovalList:{},
    tagDetails: {},
    saveModificationLog: {}
};

const salesApprovalReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case APPROVAL_LIST:
            return {
                ...state,
                approvalList: payload,
            };
        case INS_DETAILS_LIST:
            return {
                ...state,
                insDetails: payload,
            };
        case INS_APPROVAL_LIST:
            return {
                ...state,
                insApprovalList: payload,
            };
        case ACCEPT:
            return {
                ...state,
                accept: payload,
            };
        case REJECT:
            return {
                ...state,
                reject: payload,
            };
        case LEAD_APPROVAL_LIST: 
            return {
                ...state,
                leadApprovalList: payload,
            };
        case EXISTING_PROJECT_LIST:
            return {
                ...state,
                existingProjectList: payload,
            };
        case TAG_APPROVAL_LIST:
            return {
                ...state,
                tagApprovalList: payload,
            };
        case TAG_DETAILS_LIST:
            return {
                ...state,
                tagDetails: payload,
            };
        case SAVE_LOGS_FOR_CONTRACT:
            return {
                ...state,
                saveModificationLog: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default salesApprovalReducer;
